export enum NylasConnectionStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  NotConnected = 'not_connected',
  Error = 'error',
}

export type NylasConnectionStatusDto = {
  calendar: {
    connected: boolean;
    status: NylasConnectionStatus;
    has_online_meetings_authorization?: boolean;
  };
  email: { connected: boolean; status: NylasConnectionStatus };
};
